export default __webpack_public_path__ + "static/media/magnifying-glass-plus.991d0204.svg";